export const ROUTES = {
  LOGIN: 'prijava',
  REGISTER: 'registracija',
  PASSWORD_RECOVERY: 'obnova-lozinke',
  PASSWORD_RECOVERY_SUBMIT: 'obnova-lozinke-potvrda',
  MAINTENANCE: 'odrzavanje',
  VERIFICATION: 'verifikacija',
  FOUR_ZERO_FOUR: '404',
  NOT_FOUND: 'not-found',
  HOME: 'pocetna',
  HOME_CAFE: 'max-cafe',
  HOME_BETTING: 'betting',
  BETTING_TASKS: 'betting-zadaci',
  BETTING_JACKPOT: 'jackpot',
  PROFILE: 'profil',
  PROMO: 'promocije',
  QR_SCANNER: 'qr-kod',
  QR_SCANNER_CAMERA: 'kamera',
  QR_SCANNER_MANUAL_ENTRY: 'manuelni-unos',
  QR_SCANNER_MANUAL_ENTRY_FULL_PATH: 'qr-kod/manuelni-unos',
  NOTIFICATIONS: 'obavestenja',
  BAR_CODE: 'kartica',

  MY_PROFILE: 'detalji',
  TRANSACTION_HISTORY: 'transakcije',
  GAME_RULES: 'pravila-igre',
  ABOUT_APP: 'o-aplikaciji',
  TERMS_AND_CONDITIONS: 'uslovi-i-politika-privatnosti',
  LOGIN_ABOUT_APP: 'o_aplikaciji',
  SUPPORT: 'korisnicka-podrska',

  MAX_VOUCHERS: 'max-vauceri',
  MAX_VOUCHERS_SHOP: 'prodavnica',
  MAX_VOUCHERS_MY_VOUCHERS: 'moji-vauceri',

  PURCHSED_MBC_VOUCHER_DETAILS: 'detalji-kupljenog-mbc-vaucera/:id',
  AVAILABLE_MBC_VOUCHER_DETAILS: 'detalji-mbc-vaucera/:id',
  PURCHSED_PRODUCT_VOUCHER_DETAILS: 'detalji-kupljenog-robnog-vaucera/:id',
  AVAILABLE_PRODUCT_VOUCHER_DETAILS: 'detalji-robnog-vaucera/:id',
  AVAILABLE_SLOT_VOUCHER_DETAILS: 'detalji-slot-vaucera/:id',
  PURCHSED_SLOT_VOUCHER_DETAILS: 'detalji-kupljenog-slot-vaucera/:id',

  PURCHSED_MBC_VOUCHER_DETAILS_FULL_PATH: 'max-vauceri/detalji-kupljenog-mbc-vaucera',
  AVAILABLE_MBC_VOUCHER_DETAILS_FULL_PATH: 'max-vauceri/detalji-mbc-vaucera',

  PURCHSED_PRODUCT_VOUCHER_DETAILS_FULL_PATH: 'max-vauceri/detalji-kupljenog-robnog-vaucera',
  AVAILABLE_PRODUCT_VOUCHER_DETAILS_FULL_PATH: 'max-vauceri/detalji-robnog-vaucera',

  PURCHSED_SLOT_VOUCHER_DETAILS_FULL_PATH: 'max-vauceri/detalji-kupljenog-slot-vaucera',
  AVAILABLE_SLOT_VOUCHER_DETAILS_FULL_PATH: 'max-vauceri/detalji-slot-vaucera'
};
